import React from 'react'
import _ from 'lodash'
import SolutionRow from '../../components/SolutionRow'
import SolutionBox from '../../components/SolutionBox'
import StudentQualityList from '../../components/StudentQualityList'
import '../../assets/css/pages/track_progress/argument-builder-submissions.css'

const ArgumentBuilderSubmissions = props => {
  const { description, students, claims, questions } = props

  return(
    <div className='argument-builder-submissions'>
      <p className='task'>
        <span>PRIMARY QUESTION: </span>
        <span>{description}</span>
      </p>
      <div className='claims-wrapper'>
        <div className='claims-col'>
          {_.map(claims, claim =>
            <div className='claim-row'>
              <SolutionRow type={claim.isCorrect ? 'correct' : 'incorrect'}>
                <div className='row-title'>{claim.isCorrect ? 'Correct Claim:' : 'Incorrect Claim:' }</div>
                <div className='claim-text'>{claim.text}</div>
              </SolutionRow>
              {!claim.isCorrect &&
                <div className='percentage-text'>
                  <b>{Math.round(claim.percentage*100)}%</b> of students submitted answers for this claim.
                </div>
              }
            </div>
          )}
        </div>
        <div className='students-col'>
          <StudentQualityList
            title='STATUS BREAKDOWN'
            students={students}/>
        </div>
      </div>
      <div className='questions-wrapper'>
        {_.map(questions, question =>
          <div key={question.question_text} className='question-row'>
            <div className='question-col'>
              <div className='question-text-wrapper'>
                <div><b>Question:</b></div>
                <div className='question-text'>{question.question_text}</div>
              </div>
            </div>
            {_.map(question.arguments, arg =>
              <div key={arg} className='question-col'>
                <SolutionBox {...arg}/>
                <div className='student-list-wrapper'>
                  <StudentQualityList students={arg.students}/>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ArgumentBuilderSubmissions
